var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("实时人数：20")]),_c('div',[_vm._v("管理人数：2")]),_c('div',[_vm._v("劳务工人：18")])])}]

export { render, staticRenderFns }